import {
  RobotReceptionRes,
  RobotAutoReviewRes,
  RobotCancelOrderReminderRes,
  RobotPaymentReminderRes,
  RobotPraiseReminderRes,
  RobotReminderOrderRes,
} from 'services/api/dashboard';
import { sortByDate } from 'views/Dashboard/ImplementData/utils';

export const convertRobotReceptionData = (
  data: RobotReceptionRes[],
): Dashboard.RobotReceptionDaily[] => {
  const sorted = sortByDate(data);
  if (!sorted) {
    return [];
  }
  return sorted.map((item) => {
    const {
      date,
      conversationCount,
      replyConversationCount,
      replyRate,
      buyerQuestionCount,
      replyBuyerIsConvertCount,
      replyQuestionCount,
      consultConvertRate,
      replyBuyerIsConvertTradeCount,
      avgCommunicateCount,
    } = item;
    return {
      date,
      会话总量: conversationCount,
      回复会话总数: replyConversationCount,
      回复率: replyRate,
      买家咨询问题数: buyerQuestionCount,
      回复条数: replyQuestionCount,
      咨询转化买家数: replyBuyerIsConvertCount,
      咨询转化率: consultConvertRate,
      转化订单数: replyBuyerIsConvertTradeCount,
      平均沟通次数: avgCommunicateCount,
    };
  });
};

export const convertRobotContributionData = (
  data: PromiseSettledResult<
    | RobotReminderOrderRes
    | RobotPaymentReminderRes
    | RobotCancelOrderReminderRes
    | RobotPraiseReminderRes
    | RobotAutoReviewRes
  >[],
) => {
  const [reminderOrderRes, paymentRes, cancelOrderRes, commentRes, replayCommentRes] = data;
  const reminderOrder =
    reminderOrderRes.status === 'fulfilled'
      ? (reminderOrderRes.value as RobotReminderOrderRes)
      : undefined;
  const payment =
    paymentRes.status === 'fulfilled' ? (paymentRes.value as RobotPaymentReminderRes) : undefined;
  const cancelOrder =
    cancelOrderRes.status === 'fulfilled'
      ? (cancelOrderRes.value as RobotCancelOrderReminderRes)
      : undefined;
  const comment =
    commentRes.status === 'fulfilled' ? (commentRes.value as RobotPraiseReminderRes) : undefined;
  const replayComment =
    replayCommentRes.status === 'fulfilled'
      ? (replayCommentRes.value as RobotAutoReviewRes)
      : undefined;
  return {
    机器人贡献: {
      催单: reminderOrder?.rate,
      催付: payment?.rate,
      取消订单挽回: cancelOrder?.rate,
      催好评: comment?.rate,
      自动回评: replayComment?.rate,
    },
    机器人催下单每日: sortByDate(reminderOrder?.reminderOrderOfDays)?.map((item) => {
      const {
        date,
        orderReminderBuyerCount,
        orderReminderIsConvertTradeAmount,
        orderReminderDispatchCount,
        orderReminderIsConvertCount,
        orderReminderIsConvertTradeCount,
        orderReminderRate,
      } = item;
      return {
        date,
        催单下发次数: orderReminderDispatchCount,
        催单买家数: orderReminderBuyerCount,
        催单后下单买家数: orderReminderIsConvertCount,
        催单后下单买家比例: orderReminderRate,
        催单后下单订单数: orderReminderIsConvertTradeCount,
        催单后下单金额: orderReminderIsConvertTradeAmount?.currencyToAmount,
      };
    }),
    机器人催付款每日: sortByDate(payment?.robotPaymentReminderOfDays)?.map((item) => {
      const {
        date,
        paymentReminderDispatchCount,
        paymentReminderOrderCount,
        paymentReminderIsConvertCount,
        paymentReminderRate,
        paymentReminderIsConvertTradeAmount,
      } = item;
      return {
        date,
        催付下发次数: paymentReminderDispatchCount,
        催付订单数: paymentReminderOrderCount,
        催付后付款订单数: paymentReminderIsConvertCount,
        催付后付款比例: paymentReminderRate,
        催付后付款金额: paymentReminderIsConvertTradeAmount?.currencyToAmount,
      };
    }),
    机器人取消订单挽回每日: sortByDate(cancelOrder?.cancelOrderReminderOfDays)?.map((item) => {
      const {
        date,
        cancelOrderReminderDispatchCount,
        cancelOrderReminderOrderCount,
        cancelOrderReminderIsConvertCount,
        cancelOrderRate,
      } = item;
      return {
        date,
        下发挽回话术次数: cancelOrderReminderDispatchCount,
        尝试挽回订单数: cancelOrderReminderOrderCount,
        取消订单挽回数: cancelOrderReminderIsConvertCount,
        取消订单挽回率: cancelOrderRate,
      };
    }),
    机器人催好评每日: sortByDate(comment?.robotPraiseReminderOfDays)?.map((item) => {
      const {
        date,
        praiseReminderDispatchCount,
        praiseReminderOrderCount,
        praiseReminderIsConvertCount,
        praiseReminderRate,
      } = item;
      return {
        date,
        催好评下发次数: praiseReminderDispatchCount,
        催好评订单数: praiseReminderOrderCount,
        催好评后好评订单数: praiseReminderIsConvertCount,
        催好评转化率: praiseReminderRate,
      };
    }),
    机器人自动回评每日: sortByDate(replayComment?.autoReviewOfDays)?.map((item) => {
      const {
        date,
        commentCreateCount,
        fiveStarCommentCreateCount,
        fourStarCommentCreateCount,
        botHandleCommentCount,
        fiveStarBotHandleCommentCount,
        fourStarBotHandleCommentCount,
        autoReviewRate,
        fiveStarAutoReviewRate,
        fourStarAutoReviewRate,
      } = item;
      return {
        date,
        评价总量: commentCreateCount,
        '4星评价数': fourStarCommentCreateCount,
        '5星评价数': fiveStarCommentCreateCount,
        自动回评数: botHandleCommentCount,
        '自动回评数-5星': fiveStarBotHandleCommentCount,
        '自动回评数-4星': fourStarBotHandleCommentCount,
        自动回评率: autoReviewRate,
        '自动回评率-5星': fiveStarAutoReviewRate,
        '自动回评率-4星': fourStarAutoReviewRate,
      };
    }),
  };
};
